module.exports = __webpack_public_path__ + "static/media/user-mimic.4d88a32a.svg";